import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CollapseMenu = _resolveComponent("CollapseMenu")
  const _component_Segment = _resolveComponent("Segment")

  return (_openBlock(), _createBlock(_component_Segment, {
    class: "company-card",
    flat: "",
    "initial-open": $props.loading
  }, _createSlots({
    default: _withCtx(() => [
      _createVNode($setup["CompanyInfo"], {
        ref: "companyInfo",
        info: $options.info,
        loading: $props.loading,
        readonly: $props.readonly,
        onFollow: _cache[0] || (_cache[0] = $event => (_ctx.$emit('follow-company', $event))),
        onSave: $options.save
      }, null, 8 /* PROPS */, ["info", "loading", "readonly", "onSave"])
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (!!$options.sections?.length)
      ? {
          name: "extra",
          fn: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sections, (section) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: section.title
              }, [
                (section.type === 'links')
                  ? (_openBlock(), _createBlock($setup["CardCarousel"], {
                      key: 0,
                      class: "links",
                      links: section
                    }, null, 8 /* PROPS */, ["links"]))
                  : _createCommentVNode("v-if", true),
                (section.type === 'finances')
                  ? (_openBlock(), _createBlock($setup["Finances"], {
                      key: 1,
                      class: "collapse-menu",
                      data: section
                    }, null, 8 /* PROPS */, ["data"]))
                  : (section.type === 'markdown')
                    ? (_openBlock(), _createBlock(_component_CollapseMenu, {
                        key: 2,
                        loading: !section.content,
                        class: "collapse-menu",
                        title: section.title
                      }, {
                        default: _withCtx(() => [
                          _createVNode($setup["MdContent"], {
                            markdown: section.content
                          }, null, 8 /* PROPS */, ["markdown"])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["loading", "title"]))
                    : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          key: "0"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["initial-open"]))
}